import React from 'react';
import { cn } from '../cn';
import { NumberedPagination } from '../pagination/NumberedPagination';
import { CREDIT_PAGE_SIZE_OPTIONS } from './ledgerUtils';
export const PortalCreditLedgerPagination = ({ pagination, onPageChange, onLimitChange, disabled, className, }) => {
    const { page, limit, total, totalPages } = pagination;
    if (total === 0)
        return null;
    return (React.createElement("div", { className: cn('flex flex-col gap-3 border-t border-gray-100 px-4 py-3 sm:flex-row sm:items-center sm:justify-between', className) },
        React.createElement("p", { className: "text-sm text-gray-500" },
            "Showing ",
            (page - 1) * limit + 1,
            "\u2013",
            Math.min(page * limit, total),
            " of ",
            total),
        React.createElement("div", { className: "flex flex-wrap items-center gap-2" },
            React.createElement("label", { className: "flex items-center gap-2 text-sm text-gray-600" },
                React.createElement("span", null, "Rows"),
                React.createElement("select", { value: limit, onChange: (e) => onLimitChange(Number(e.target.value)), disabled: disabled, className: "h-9 rounded-lg border border-gray-200 bg-white px-2 text-sm", "aria-label": "Rows per page" }, CREDIT_PAGE_SIZE_OPTIONS.map((n) => (React.createElement("option", { key: n, value: n }, n))))),
            React.createElement(NumberedPagination, { currentPage: page, totalPages: Math.max(1, totalPages), onPageChange: onPageChange, disabled: disabled, variant: "portal", prevLabel: "<", nextLabel: ">" }))));
};
export default PortalCreditLedgerPagination;
